export default "__VITE_ASSET__C0Rv4Jba__"